import { motion } from "framer-motion";

export default function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section className="relative pt-44 pb-24 md:pt-52 md:pb-28 overflow-hidden">
      <div className="absolute inset-0">
        {image ? (
          <>
            <img src={image} alt={title} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gl-bg/85" />
            <div className="absolute inset-0 bg-gl-primary/25 mix-blend-multiply" />
          </>
        ) : (
          <div className="absolute inset-0 bg-gl-bg2/50" />
        )}
      </div>
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl"
        >
          {eyebrow && (
            <span className="text-gl-gold uppercase tracking-[0.35em] text-xs md:text-sm mb-5 block">
              {eyebrow}
            </span>
          )}
          <h1 className="font-serif-display text-5xl md:text-6xl font-light leading-[1.05] text-gl-text">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 text-lg md:text-xl text-gl-text2 font-light leading-relaxed">
              {subtitle}
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
}
